 

export default class ProfssionalTeam {

    Id: string | undefined;
    TeamName: string | undefined;
    BossName: string | undefined;
    TeamTasyCode: number | undefined;
    OccupationTasyCode: number | undefined;
    OccupationName: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;
    
    static NewInstance() {
        return new ProfssionalTeam();
    }
}